function openSubmenu(el, blockID) {
  const subMenu = document.querySelector(("#drawer_submenu--" + blockID))
  subMenu.classList.add('open')
} 

function closeSubmenu(el, blockID) {
  const subMenu = document.querySelector(("#drawer_submenu--" + blockID))
  subMenu.classList.remove('open')
} 

function openQuestion(el) {
  if(el.parentElement.classList.contains('active'))
    el.parentElement.classList.remove('active')
  else
    el.parentElement.classList.add('active')
}

function checkTerms(event, form) {
  event.preventDefault()
  
  const checkbox = form.querySelector('#agree-terms')
  const button = form.querySelector("button[name='checkout']")
  
  if (checkbox.checked) {
    window.location.href ='/checkout'
    return true
  } else {
    alert("חובה לאשר את התקנון")
    button.classList.remove('btn--loading')
    button.removeAttribute ('disabled')
    return false
  }
}

function openBlock(block, el) {
  let i;
  const tabs = document.getElementsByClassName("tabs-buttons__button")
  const contents = document.getElementsByClassName("product-tabs__block")
  
  for (i = 0; i < tabs.length; i++) {
    tabs[i].classList.remove('active')
    contents[i].classList.remove('active')
  }

  el.classList.add('active')
  document.getElementById(block).classList.add('active')
}

function toggle3d() {
  const model = document.querySelector('#d-model')
  const body = document.querySelector('body')
  
  if (model != null) {
    let data = model.dataset.hidden
    if (data == 'true') {
      model.dataset.hidden = 'false'
      body.style.overflow = 'hidden'
    } 
    else {
     body.style.overflow = 'auto' 
     model.dataset.hidden = 'true'
    }
  }
}

function toggleRing() {
  const model = document.querySelector('#ring-model')
  const body = document.querySelector('body')
  
  if (model != null) {
    let data = model.dataset.hidden
    if (data == 'true') {
      model.dataset.hidden = 'false'
      body.style.overflow = 'hidden'
    } 
    else {
      model.dataset.hidden = 'true'
      body.style.overflow = 'auto'
    }
  }
}

$('.product-media__wrapper').slick({
  dots: true,
  arrows: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  rtl: true,
  fade: true,
  autoplay: true,
  autoplaySpeed: 1000
});

window.addEventListener("scroll", function() {
  const popup = document.querySelector(".atc-popup__wrapper");
  const header = document.querySelector(".product-single");

  if (header && popup) {
    if (window.scrollY > (header.offsetTop + header.offsetHeight)) {
      popup.classList.add('active')
    } else
      popup.classList.remove('active')
  }
});
            
function addBags(e, el) {
  e = e || window.event;
  e.preventDefault();

  let formData = {
    'items': [
      {
        'id': '43765593669817',
        'quantity': 1
      }
    ]
  };
    
  el.setAttribute('disabled', 'disabled');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then((resp) => { 
    return resp.json();
  })
  .then((data) => {
    el.removeAttribute ('disabled');
    document.dispatchEvent(new CustomEvent("dbtfy:updateCart"))
  })
  .catch((err) => {
    console.error('Error: ' + err);
  })
}

function addBagsy2(e, el) {
  e = e || window.event;
  e.preventDefault();

  let formData = {
    'items': [
      {
        'id': '44345438666937',
        'quantity': 1
      }
    ]
  };
    
  el.setAttribute('disabled', 'disabled');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then((resp) => { 
    return resp.json();
  })
  .then((data) => {
    el.removeAttribute ('disabled');
    document.dispatchEvent(new CustomEvent("dbtfy:updateCart"))
  })
  .catch((err) => {
    console.error('Error: ' + err);
  })
}